<div class="admin-page">
    <div class="admin-card">
        <div class="admin-card-header">
            <!-- <div class="go-back-button" (click)="goBack()" *ngIf="previousPage && previousPage !== ''"> -->
            <div class="go-back-button" (click)="goBack()" *ngIf="router.url !== '/administration'">
                <!-- <div class="go-back-button" (click)="goBack()"> -->
                <object class="button" type="image/svg+xml" data="/assets/icons-white/chevron-bottom.svg"></object>
            </div>
            <div class="title">{{title}}</div>
            <div class="logout-button" (click)="logout()">
                <object class="button" type="image/svg+xml" data="/assets/icons-white/sortie.svg"></object>
            </div>
        </div>
        <router-outlet></router-outlet>
    </div>
</div>